import { render, staticRenderFns } from "./ModerateProfilePage.vue?vue&type=template&id=87acf67c&scoped=true&"
import script from "./ModerateProfilePage.vue?vue&type=script&lang=js&"
export * from "./ModerateProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./ModerateProfilePage.vue?vue&type=style&index=0&id=87acf67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87acf67c",
  null
  
)

export default component.exports